import { Loading } from "@winamp/icons/Loading.js";
import { Dialog, type DialogProps } from "./Dialog";

type DialogWrapperProps = DialogProps & {
  loading: boolean;
};

export function DialogWrapper({ loading, open, ...props }: DialogWrapperProps) {
  return (
    <>
      <Dialog
        {...props}
        open={open && loading}
        className="flex items-center justify-center sm:size-32"
      >
        <Loading className="animate-spin size-10" />
      </Dialog>

      <Dialog {...props} open={open && !loading} />
    </>
  );
}
